/** @file partName: a drawable id as plain words for an image model (armL is arm, left). */

/** Camel-case words, a trailing single `L` / `R` as `left` / `right`, dots and digits kept: `att0.sword` is `att0 sword`. */
export function partName(drawable: string): string {
  const side = /^(.*[a-z0-9])([LR])$/.exec(drawable);
  const base = side?.[1] ?? drawable;
  const words = base.replace(/([a-z0-9])([A-Z])/g, '$1 $2').replaceAll('.', ' ').toLowerCase();
  if (side === null) return words;
  return `${words}, ${side[2] === 'L' ? 'left' : 'right'}`;
}
